import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from 'components/Icons/types'

const Svg = styled.svg`
  height: 16px;
  width: 16px;
`

export const FilledDownloadIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="8" fill="#FF627B" />
      <path
        d="M8 9.52567L5.15383 6.6795L5.8565 5.9565L7.5 7.6V2H8.5V7.6L10.1435 5.9565L10.8462 6.6795L8 9.52567ZM4.20517 12C3.86839 12 3.58333 11.8833 3.35 11.65C3.11667 11.4167 3 11.1316 3 10.7948V8.98717H4V10.7948C4 10.8462 4.02139 10.8932 4.06417 10.9358C4.10683 10.9786 4.15383 11 4.20517 11H11.7948C11.8462 11 11.8932 10.9786 11.9358 10.9358C11.9786 10.8932 12 10.8462 12 10.7948V8.98717H13V10.7948C13 11.1316 12.8833 11.4167 12.65 11.65C12.4167 11.8833 12.1316 12 11.7948 12H4.20517Z"
        fill="#F8F8F8"
      />
    </Svg>
  )
}
